
  const password = document.getElementById('RegisterForm-password');
  const marketing = document.getElementById('RegisterForm-Marketing');
  const loyalty = document.getElementById('RegisterForm-Loyalty');
  const submitBtn = document.querySelector('.register-button');
  
  const passwordError = document.getElementById('RegisterForm-password-error');
  const marketingError = document.getElementById('RegisterForm-marketing-error');
  const loyaltyError = document.getElementById('RegisterForm-loyalty-error');

  if (!password || !submitBtn) return;

  function validateForm() {
    let valid = true;

   const passwordValue = password.value.trim();
   const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;

    if (!passwordRegex.test(passwordValue)) {
      if (passwordError) passwordError.hidden = false;
      valid = false;
    } else {
      if (passwordError) passwordError.hidden = true;
    }

    if (marketing) {
      if (!marketing.checked) {
        if (marketingError) marketingError.hidden = false;
        valid = false;
      } else {
        if (marketingError) marketingError.hidden = true;
      }
    }

    if (loyalty) {
      if (!loyalty.checked) {
        if (loyaltyError) loyaltyError.hidden = false;
        valid = false;
      } else {
        if (loyaltyError) loyaltyError.hidden = true;
      }
    }

    submitBtn.disabled = !valid;
    
   const emailError = document.querySelector('.errors-list li')
   if (!emailError) return;

    const html = emailError.innerHTML;

    const textarea = document.createElement('textarea');
    textarea.innerHTML = html;
    const decoded = textarea.value;
      
    emailError.innerHTML = decoded;
    }

  password.addEventListener('input', validateForm);
  marketing?.addEventListener('change', validateForm);
  loyalty?.addEventListener('change', validateForm);

  validateForm();
 

